<div class="search-parameters">

    <div class="advanced-search">
        <!-- <form #siteForm="ngForm" (ngSubmit)="onSearchSites()"> -->
        <div class="col col1">
            <div class="label">Name:</div>
            <div class="label">Customer ID:</div>
            <div class="label">Customer Name:</div>
        </div>
        <div class="col col2">
            <div class="input">
                <input matInput type="text" id="name" name="name" [(ngModel)]="siteSearchParams.name">
            </div>
            <div class="input">
                <input matInput type="text" id="customerId" name="customerId" [(ngModel)]="siteSearchParams.customerId">
            </div>
            <div class="input">
                <input matInput type="text" id="customerName" name="customerName"
                    [(ngModel)]="siteSearchParams.customerName">
            </div>
        </div>
        <div class="col col3">
            <div class="label">Country:</div>
            <div class="label">Region:</div>
            <div class="label">City:</div>
        </div>
        <div class="col col4">
            <div class="input">
                <input matInput type="text" id="country" name="country" [(ngModel)]="siteSearchParams.country">
            </div>
            <div class="input">
                <input matInput type="text" id="region" name="region" [(ngModel)]="siteSearchParams.region">
            </div>
            <div class="input">
                <input matInput type="text" id="city" name="city" [(ngModel)]="siteSearchParams.city">
            </div>
        </div>
        <div class="col col5">
            <button class="search-button" mat-raised-button color="primary" (click)="onSearchSites()"
                [disabled]="!siteSearchParams.name && !siteSearchParams.customerId && !siteSearchParams.customerName && !siteSearchParams.country && !siteSearchParams.region && !siteSearchParams.city">
                <mat-icon>search</mat-icon>
                Search
            </button>
        </div>
        <!-- </form> -->
    </div>
</div>

<div class="search-results">

    <div class="empty-resultset" *ngIf="loading">
        Loading...
      </div>
    
      <div class="empty-resultset" *ngIf="!loading && sites && sites.length == 0">
        No sites have been found
      </div>
    
      <div class="empty-resultset" *ngIf="!loading && sites==null">
        Enter search criteria
      </div>

    <ng-container *ngFor="let site of sites">
        <site-search-result-item [site]="site" />
    </ng-container>

    <div #loadingTrigger class="loading-trigger">
        <p *ngIf="moreDataAvailable">Loading...</p>
    </div>
</div>